import React, { useContext, useEffect, useState } from "react";
import { FlinkContext } from "../../context/FlinkContext";
import Logger from "../../Helper/Logger";
import LineChart from "../Chart/LineChart";
import Loading from "../Loading/Loading";
import overviewCards from "../Overview/OverviewCard/OverviewDummy";
import Title from "../Title/Title";

function FlinkForecast() {
  const dataForecast = useContext(FlinkContext);
  const [forecast, setForecast] = useState(null);
  useEffect(() => {
    setForecast(dataForecast.forecasts);
  }, [dataForecast]);

  return (
    <div className="Flink-container">
      {forecast ? (
        <Logger op="Chart" id="17152" className="">
          <Title title="forecasts" icon={overviewCards.forecasts.icon} />
          <div className="row">
            <div className="col-md-6 col-sm-6">
              <LineChart
                yAxisTitle="°C"
                data={forecast.temperatureChart}
                colors={["#004474", "#70cff9"]}
                showLegend
                day
              />
            </div>
            <div className="col-md-6 col-sm-6">
              <LineChart
                yAxisTitle="MWh"
                data={forecast.windChart}
                colors={["#004474", "#70cff9"]}
                showLegend
                day
              />
            </div>
          </div>
        </Logger>
      ) : (
        <Loading />
      )}
    </div>
  );
}

export default FlinkForecast;
